import React from "react";

import { RadioButtonGroupProps } from "@models/components/formElements.model";

import RadioButtonBox from "../RadioButtonBox/RadioButtonBox";

const RadioButtonGroups: React.FC<RadioButtonGroupProps> = ({ groups }) => {
  return (
    <div
      className="btn-group fg-filter-btn-group"
      role="group"
      aria-label="basic radio toggle button group"
      data-testid="radio-button-group"
    >
      {groups.map(group => (
        <RadioButtonBox
          id={group.id}
          key={group.id}
          label={group.label}
          name={group.name}
          setValue={group.setValue}
          value={group.value}
        />
      ))}
    </div>
  );
};

export default RadioButtonGroups;
